import { Component, Input } from '@angular/core';



interface BenefitsPanelItem {
  iconUrl: string;
  title: string;
  subtitle: string;
}
@Component({
  selector: 'unh-benefits-panel',
  templateUrl: './benefits-panel.component.html',
  styleUrls: ['./benefits-panel.component.scss']
})
export class BenefitsPanelComponent  {

  @Input() sectionTitle: string;

  @Input() sectionSubtitle: string;

  @Input() items: BenefitsPanelItem[]

}
